import { AppState } from 'app/store';

export const getStorageService = (state: AppState) =>
  state.auth.services?.['storage-tracker'];

export const getStorageLink = (state: AppState) =>
  state.auth.services?.['storage-tracker']?._links.getStorage;

export const getStorage = (state: AppState) => state.storage.storage;

export const getStorageLoadingState = (state: AppState) =>
  state.storage.storageLoadingState;

export const getShowUpgradePopup = (state: AppState) =>
  state.storage.showUpgradePopup;

export const getUpgradePopupOverlay = (state: AppState) =>
  state.storage.disableOverlay;
